import React from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import LoadingPanel from '../../../components/LoadingPanel';
import HardwareProductsTable from '../hardwareProducts/components/HardwareProductsTable';
import SoftwareProductsTable from '../softwareProducts/components/SoftwareProductsTable';
import { Checkbox } from '../../../../common/components';
import { hardwareProducts, softwareProducts } from '../../../../modules/customer/profile';

const statesPossibleToCancel = ["Active", "Frozen","PendingDateActivation", "PendingSystemActivation", "PendingDisconnection", "PendingCancellation", "PendingFreeze"];

const isPossibleToCancel = status => statesPossibleToCancel.indexOf(status) !== -1;

const CancelationOptionsStep = ({ hardwareProducts, softwareProducts, isLoadingSoftware, isLoadingHardware}) => {
    const cancellableHardware = hardwareProducts.productsList.filter((item) => isPossibleToCancel(item.status));
    const softwareProductsToDisplay = softwareProducts.productsList.filter((item) => !(item.name.includes("2-4") || item.name.includes("rabattert")))
    //const possibleToCancelSubscriptions = softwareProductsToDisplay.filter((item) => isPossibleToCancel(item.status));
    return <div>
        { isLoadingHardware && <LoadingPanel/>}
        {!isLoadingHardware && <HardwareProductsTable hardwareProductsList={cancellableHardware} editMode="true" />}
    </div>
    // TODO - cancel software
    /*return (
        <div className="col-xs-12">
            <table className="col-xs-12 container cancelationBox">
                <tbody>
                    <tr>
                        <td className="col-xs-2 boxColumn accentedText contentColumn" >
                            <div>
                                <div className="row-fluid subscription-section">
                                    <span><strong>Avbryt hele kontoen</strong></span>
                                </div>
                                <div className="productBoxContent">
                                    <Checkbox label="Velg alt" />
                                </div>
                            </div>
                        </td>
                        <td className="col-xs-4 boxColumn accentedText contentColumn" style={{paddingRight: 5 + 'px'}}>
                            { isLoadingSoftware ? <LoadingPanel/> : <SoftwareProductsTable softwareProductsList={possibleToCancelSubscriptions} editMode="true" tableName='Subscription' />}
                        </td>
                        <td className="col-xs-6 mb30 boxColumn contentColumn" style={{paddingLeft: 5 + 'px', borderLeft:"1px solid #c0d8e5"}}>
                            { isLoadingHardware ? <LoadingPanel/> : <HardwareProductsTable hardwareProductsList={possibleToCancelProducts} editMode="true" />}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );*/
};


const mapStateToProps = createStructuredSelector({
    hardwareProducts: hardwareProducts.selectors.getHardwareProducts,
    softwareProducts: softwareProducts.selectors.getSoftwareProducts,
    isLoadingSoftware: softwareProducts.selectors.isLoading,
    isLoadingHardware: hardwareProducts.selectors.isLoading,
});

export default connect(mapStateToProps)(CancelationOptionsStep);